import { Editor } from "tinymce";

export const Functions = (editor: Editor) => {
  editor.on("init", () => {
    const tinyMceLoaded = new CustomEvent("tinyMceLoaded", { detail: { editor } });
    document.dispatchEvent(tinyMceLoaded);
  });
  editor.ui.registry.addButton("firstName", {
    text: "First Name",
    icon: "plus",
    tooltip: "Insert Candidate First Name",
    onAction: function () {
      editor.insertContent("[[FirstName]]");
    },
  });
  editor.ui.registry.addButton("lastName", {
    text: "Last Name",
    icon: "plus",
    tooltip: "Insert Candidate Last Name",
    onAction: function () {
      editor.insertContent("[[LastName]]");
    },
  });
};
